import { dataMove } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMove = /*#__PURE__*/createIcon(dataMove)
export default IconMove
